const Orcamento = () => import('../../spa/orcamento/Orcamento');
const OrcamentoList = () => import('../../spa/orcamento/OrcamentoList');
const OrcamentoForm = () => import('../../spa/orcamento/OrcamentoForm');
const RateioOrcamento = () => import('../../spa/orcamento/RateioOrcamento');

export default {
  path: 'orcamento',
  component: Orcamento,
  children: [
    {
      path: '',
      name: 'orcamento',
      component: OrcamentoList,
    },
    {
      path: 'novo',
      name: 'novoOrcamento',
      component: OrcamentoForm,
      props: {
        default: false,
        somenteLeitura: false,
        copia: false,
        edicao: false,
        novo: true,
      },
    },
    {
      path: ':id',
      name: 'verOrcamento',
      component: OrcamentoForm,
      props: {
        default: true,
        somenteLeitura: true,
        copia: false,
        edicao: false,
        novo: false,
        fluxo: false,
      },
    },
    {
      path: ':id/fluxo',
      name: 'verOrcamentoFluxo',
      component: OrcamentoForm,
      props: {
        default: true,
        somenteLeitura: true,
        copia: false,
        edicao: false,
        novo: false,
        fluxo: true,
      },
    },
    {
      path: ':id/editar',
      name: 'editarOrcamento',
      component: OrcamentoForm,
      props: {
        default: true,
        somenteLeitura: false,
        copia: false,
        edicao: true,
        novo: false,
      },
    },
    {
      path: ':id/copiar',
      name: 'copiarOrcamento',
      component: OrcamentoForm,
      props: {
        default: true,
        somenteLeitura: false,
        copia: true,
        edicao: false,
        novo: false,
      },
    },
    {
      path: ':id/rateio',
      name: 'rateioOrcamento',
      component: RateioOrcamento,
      props: {
        default: true,
        somenteLeitura: false,
        copia: false,
        edicao: true,
        novo: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/orcamento.js